
<template>
    <div v-if="showModel" class="edit-model">
        <div class="img-div">
            <div>{{title}}</div>
            <div class="close-img" @click="cancel"><i class="iconfont">&#xe641;</i></div>
        </div>
       
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem label="角色名称" prop="name">
                <Input type="text" v-model="formData.name"></Input>
            </FormItem>
            <FormItem label="角色描述" prop="describe">
                <Input type="text" v-model="formData.describe"></Input>
            </FormItem>
            <FormItem label="状态" prop="status" class="ivu-form-item-required">
                <RadioGroup v-model="formData.status" >
				  <Radio label="1" >
				  	<span>正常</span>
				  </Radio>
				  <Radio label="2" >
				  	<span>禁用</span>
				  </Radio>
                  <Radio label="3" >
				  	<span>禁删</span>
				  </Radio>
			    </RadioGroup>
            </FormItem>
            <FormItem label="角色" prop="permission_ids" class="ivu-form-item-required">
                <div class="per-list" >
                    <div style="display: flex;align-items: center;" class="item-list item-class1" v-for="(item,index) in list" :key="index">
                            <div class="title title1 " style="color: #333;">
                                <Checkbox @on-change='change1($event,item,index)'  v-model='item.offCheck'><span>{{item.name}}</span></Checkbox>
                            </div>
                            <div class="titlle-children titlle1-children">
                                <div style="display: flex;align-items: center;flex:1;" class="item-list item-class2"  v-for="(item1,index1) in item.children" :key="index1">
                                    <div class="title title2" style="color: ##333;"><Checkbox @on-change='change2($event,item1,index1,index)' v-model='item1.offCheck'><span>{{item1.name}}</span></Checkbox></div>
                                    
                                    <div class="titlle-children titlle2-children item-class3">
                                        <div class="title" style="color: ##333;flex:1" v-for="(item2,index2) in item1.children" :key="index2"><Checkbox @on-change='change3($event,index,index1,index2)' v-model='item2.offCheck'><span>{{item2.name}}</span></Checkbox></div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </FormItem>
            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
        </Form>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from "@/common/common";
export default {
  props: {
    showModel: Boolean,
    fn: Function,
    type: Number,
    editFormData: Object
  },
  name: "Model1",
  components: {
  },
  data() {
    return {
      title: "添加/编辑",
      disabled: false,
      list:[],
      defaultData:{
        id: '',
        name: "",
        describe: "",
        status: "1",
        permission_ids: [],
      },
      formData: {},
      checkAllGroup:[],
      list_new:[],
      ruleCustom: {
        //验证
        name: [
          { required: true, message: "名称必须填写", trigger: "blur" },
        ],
        describe: [
          { required: true, message: "角色描述必须填写", trigger: "blur" },
        ],
      },
      
    };
  },
  watch: {
    async showModel(val) {
        this.getRoleData()
		setTimeout(() => {
            if(val){
                if (this.type && this.type == 2) {
                    this.editForm()
                }
                if(this.type && this.type == 1){
                    this.formData = this.defaultData
                }
            }
        }, 500);
    },
  },
  methods: {
    change1(e,item,index){
        let off = e
        if(this.list[index].hasOwnProperty('children'))
        this.list[index].children.map((item,index)=>{
            item.offCheck = off
            if(item.hasOwnProperty('children')){
                item.children.map((item1,index1)=>{
                    item1.offCheck = off
                })
            }
            return item
        })
    },
    change2(e,item1,index1,index){
        let off = e
        if(this.list[index].children[index1].hasOwnProperty('children')){
            console.log('sss')
            this.list[index].children[index1].children.map((item1,index1)=>{
                item1.offCheck = off
                return item1
            })
        }
        
        let nums = 0
        this.list[index].children.map((item,index)=>{
            if(item.offCheck){
                nums++
            }
        })
        if(nums > 0){
            this.list[index].offCheck = true
        }else{
            this.list[index].offCheck = false
        }
    },
    change3(e,index,index1,index2){
            let nums = 0
            this.list[index].children[index1].children.map((item,index)=>{
                if(item.offCheck){
                    nums ++ 
                }
            })
            if(nums<=0){
                this.list[index].children[index1].offCheck = false
            }else{
                this.list[index].children[index1].offCheck = true
            }
            let nums1 = 0
            this.list[index].children.map((item1,index1)=>{
                if(item1.offCheck){
                    nums1 ++ 
                }
            })
            if(nums1<=0){
                this.list[index].offCheck = false
            }else{
                this.list[index].offCheck = true
            }
    },
    checkAllGroupChange1(data){
        console.log(data)
    },
    editForm() {
	  for(let key in this.defaultData){
		  this.defaultData[key]=(this.editFormData[key] instanceof Array || this.editFormData[key] instanceof Object )?this.editFormData[key] : String(this.editFormData[key])
		  if(!this.editFormData[key]){
		    this.defaultData[key] = ''
		  } 
	  }
      this.formData = this.defaultData;
      this.formData.permission_ids.map((item,index)=>{
          item = Number(item)
          return item
      })
      this.checkAllGroup = this.formData.permission_ids
         this.$nextTick(() => {
            this.list_new.map((fItem,FIndex)=>{
                let offIndex1 = this.checkAllGroup.findIndex(((mItem1,mIndex1)=> {return mItem1 == fItem.id})) 
                if(offIndex1 > -1){
                fItem.offCheck = true
                }
                if(fItem.hasOwnProperty('children')){
                    fItem.children.map((item,index)=>{
                        let offIndex2 = this.checkAllGroup.findIndex(((mItem1,mIndex1)=> {return mItem1 == item.id})) 
                        if(offIndex2 > -1){
                            item.offCheck = true
                        }
                        if(item.hasOwnProperty('children')){
                            item.children.map((item1,index1)=>{
                                let offIndex3 = this.checkAllGroup.findIndex(((mItem1,mIndex1)=> {return mItem1 == item1.id})) 
                                if(offIndex3 > -1){
                                    item1.offCheck = true
                                }
                                return item1
                            })
                        }
                        return item
                    })
                }
                return fItem
            })
            this.list = this.list_new
        })
        
    },
    getRoleData(){ //获取数据
        this.axios.get(this.config.urlArray.rolesPermission,{}).then((result) => {
        common.ajaxMsg(result.data);
        let resData = result.data.data
        this.list_new = resData
        if(this.type == 1){
           this.list =  this.list_new
        }
    }).catch((err) => {
        common.msg('error','获取失败',()=>{})
    });
    },
    subData(name) {
        console.log(this.list)
      //提交表单
      this.$refs[name].validate(valid => {
        if (valid) {
          this.disabled = true;
            this.formData.permission_ids = []
            this.list.map((fItem,FIndex)=>{
                if(fItem.offCheck){
                    console.log('ahh ')
                    let offIndex = this.formData.permission_ids.findIndex(((mItem1,mIndex1)=> {return mItem1 == fItem.id})) 
                     console.log('offIndex',offIndex,this.formData.permission_ids)
                    if(offIndex>=-1) {this.formData.permission_ids.push(fItem.id)}
                    
                }
                
                if(fItem.children){
                    fItem.children.map((item,index)=>{
                        if(item.offCheck){
                            let offIndex1 = this.formData.permission_ids.findIndex(((mItem1,mIndex1)=> {return mItem1 == item.id})) 
                            if(offIndex1 >= -1) {this.formData.permission_ids.push(item.id)}
                        }
                        if(item.children){
                            item.children.map((item1,index1)=>{
                               
                                    if(item1.offCheck){
                                        let offIndex2 = this.formData.permission_ids.findIndex(((mItem1,mIndex1)=> {return mItem1 == item1.id})) 
                                        if(offIndex2 >= -1) {this.formData.permission_ids.push(item1.id)}
                                    }
                            })
                        }
                    })
                }
            })
          this.axios
            .post(this.config.urlArray.rolesStore, this.formData)
            .then(result => {
              common.ajaxMsg(
                result.data,
                true,
                () => {
                  //提交表单后的回调处理
                  this.resetForm(); //重置表单
                  this.fn();
                },
                () => {
                  this.disabled = false;
                }
              );
            })
            .catch(err => {
              common.msg("error", "提交失败", () => {
                this.disabled = false;
              });
            });
        }
      });
    },
    cancel() {
      //对话框关闭
      this.$emit("update:showModel", false);
      this.fn();
      this.resetForm()
    },
    setThumbUrl(url) {
      //获取图片上传后的路径
      this.formData.thumb = url;
    },
    resetForm() {
        this.list = []
      this.defaultData = {
        id: '',
        name: "",
        describe: "",
        status: "1",
        permission_ids: [],
      }
      this.checkAllGroup = []
      this.list_new = []
      //重置表单
      this.formData.id = '';
      this.$refs.formData.resetFields(); //重置表单
      this.disabled = false; //恢复提交按钮为激活状态
    }
  }
};
</script>
<style lang='scss' scoped>
.edit-model{
    position: relative;
    .img-div{
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 45px;
        div{
            font-weight: bold;
            font-size: 15px;
        }
    }
    .close-img{
        border: 1px solid #fd6363;
        display: inline-block;
        line-height: 100%;
        border-radius: 100%;
        padding: 5px;
        color: #f00;
        right: 10px;
        top: 10px;
        z-index: 3;
        cursor: pointer;
    }
    .close-img:hover{
        transform: scale(1.1);
        transition: all 0.3s;
    }
}
.per-list{
    .item-list{
        // border: 1px solid red;
        word-break: break-all;
        .title{
            width: 180px;
            padding: 0px 10px;
            box-sizing: border-box;
            span{
                margin-left: 10px;
                font-size: 14px;
            }
        }
        // margin: 5px 10px;
        .titlle-children{
            // width: 100%;
            flex: 1;
            border-left: 1px solid #d2d2d2;
            // display: flex;
            // align-items: center;
            // margin: 5px 10px;
        }
    }
    .item-class1{
         border: 1px solid #d2d2d2;
         margin-top:-1px;
        // border-bottom: 1px solid #d2d2d2;
    }
    .item-class2{
        border-top: 1px solid #d2d2d2;
        margin-top:-1px;
        // border-top: 1px solid #d2d2d2;
        // border-left: 1px solid #d2d2d2;
    }
    .item-class3{
        // border: 1px solid #d2d2d2;
        // margin-top:-1px;
        
        // border-top: 1px solid #d2d2d2;
    }
}
</style>